module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/img-14-4328108112a7b0a1a3a161b5c3664672.png";